import { baseApi } from 'api/api-base';
import { API_ROUTES } from 'constants/api-routes';
import { DashboardData, GetUserData } from 'types/api/api-user.types';

export const locationApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getLocations: builder.query<GetUserData.ResponseType, GetUserData.RequestType>({
      query: () => ({
        url: API_ROUTES.LOCATIONS,
      }),
      providesTags: ['Account'],
      extraOptions: {},
      transformResponse: (response: GetUserData.RawApiResponse | DashboardData): GetUserData.ResponseType => {
        if ('success' in response && response.success && 'data' in response) {
          return response.data;
        }
        return response as DashboardData;
      },
    }),
  }),
});

export const { useGetLocationsQuery } = locationApi;
